/**
 *  nicejob-toolbox
 *  https://github.com/nicejobinc/nicejob-toolbox
 *
 *  Shared set of functions for common operations across microservices.
 *
 *  See README for usage example.
 */

/**
 * Environment
 */
import environmentVariables from './util/environmentVariables';
export { environmentVariables };
environmentVariables();

/**
 * Method imports & exports
 * - Export here
 * - Add to Toolbox below
 */
import dateString from './methods/dateString';
import isServiceOutage from './methods/isServiceOutage';
import parseDateInterval from './methods/parseDateInterval';
import reviewFingerprint from './methods/reviewFingerprint';
import validDate from './methods/validDate';
import validateEmail from './methods/validateEmail';
import parseConstants from './util/parseConstants';
export {
    dateString,
    isServiceOutage,
    parseConstants,
    parseDateInterval,
    reviewFingerprint,
    validDate,
    validateEmail,
};

/**
 * Constants & Globals
 */
export const constants = parseConstants();

export const Online = process.env.NODE_ENV === 'production';
export const online = Online;
export const DEFAULT_PROJECT = (constants && constants.projects && constants.projects.exp) || null;
export const PROJECT_ID =
    process.env.GCP_PROJECT ||
    process.env.GCLOUD_PROJECT ||
    process.env.GOOGLE_CLOUD_PROJECT ||
    process.env.PROJECT_ID;
export const PROJECT_KEY =
    Object.keys((constants && constants.projects) || {}).find(
        key => PROJECT_ID === constants.projects[key]
    ) || PROJECT_ID;
export const PROJECT_REGION = process.env.PROJECT_REGION || 'us-central1';

/**
 * Toolbox
 */
const Toolbox = {
    /**
     * Constants
     */
    DEFAULT_PROJECT,
    PROJECT_ID,
    PROJECT_KEY,
    PROJECT_REGION,

    online,
    Online,

    ...(constants || {}),

    /**
     * Methods
     */
    dateString,
    isServiceOutage,
    parseDateInterval,
    validateEmail,
    validDate,
};

export default Toolbox;
